import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryWebsiteDetailById = async (params: object) => {
  return await GET({
    url: Api.queryWebsiteDetailById,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier'
    }
  })
}
